import React, {useState} from "react";


const BoolProp = ({propertyname, value, default_, onChange, array, arrayindex}) => {

    const [v, setv] = useState(Boolean(value || default_));

    function handleChange(e) {
        let val = Boolean(e)
        setv(val)
        onChange(propertyname, val, array, arrayindex)
    }

    return (
        <input type="checkbox" name={propertyname} checked={v} onChange={(event) => handleChange(event.target.checked)}/>
    )
}

export default BoolProp